import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Location, PopStateEvent } from "@angular/common";
import { environment } from '../environments/environment';

import { AdobeScriptService } from './service/adobe-script.service';

import { Adal5Service } from 'adal-angular5';
import { adal } from 'adal-angular';

const config: adal.Config = {
  tenant: environment.azure_tenant,
  clientId: environment.clientId,
  extraQueryParameter: environment.azure_default_parameter,
  redirectUri: window.location.origin + '/docs',
  instance: environment.azure_instance,
  postLogoutRedirectUri: window.location.origin
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];

    constructor(private service: Adal5Service, private router: Router, private location: Location, private adobe: AdobeScriptService) {
      this.service.init(config);
    }

    ngOnInit() {
      if (environment.production || environment.qa) {
        this.adobe.load();
      }

      this.service.handleWindowCallback();

      this.location.subscribe((ev:PopStateEvent) => {
        this.lastPoppedUrl = ev.url;
      });

      this.router.events.subscribe((ev:any) => {
        if (ev instanceof NavigationStart) {
          if (ev.url != this.lastPoppedUrl) {
            this.yScrollStack.push(window.scrollY);
          }
        } else if (ev instanceof NavigationEnd) {
          if (ev.url == this.lastPoppedUrl) {
            this.lastPoppedUrl = undefined;
            window.scrollTo(0, this.yScrollStack.pop());
          } else {
            window.scrollTo(0, 0)
          }
        }
      });
    }
  
    // Logout Method
    public logout() {
      this.service.logOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts